<template>
  <div class="stat-panel h-100">
    <div class="stat-panel-head">
      <div>
        <h5>بزرگ‌ترین سفارش</h5>
        <p class="text-muted mb-0 small">بالاترین مبلغ ثبت‌شده تا امروز</p>
      </div>
      <i class="bi bi-receipt text-primary"></i>
    </div>

    <template v-if="hasOrder">
      <div class="biggest-user">
        <div class="biggest-avatar">{{ userInitial }}</div>
        <div>
          <strong>{{ userFullName }}</strong>
          <span>مشتری سفارش</span>
        </div>
      </div>

      <div class="biggest-row">
        <span>قیمت</span>
        <strong>{{ formatNumber(order.total_amount) }} تومان</strong>
      </div>
      <div class="biggest-row">
        <span>تخفیف</span>
        <strong>{{ formatNumber(order.offer_amount) }} تومان</strong>
      </div>
      <div class="biggest-row">
        <span>هزینه ارسال</span>
        <strong>{{ formatNumber(order.delivery_amount) }} تومان</strong>
      </div>
      <div class="biggest-row is-total">
        <span>قابل پرداخت</span>
        <strong>{{ formatNumber(order.paying_amount) }} تومان</strong>
      </div>
      <div class="biggest-row">
        <span>تاریخ پرداخت</span>
        <strong dir="ltr">{{ paymentDate }}</strong>
      </div>

      <m-a class="btn stat-action-btn" :href="{name:'Factor',params:{orderId:order.id}}">
        مشاهده فاکتور
      </m-a>
    </template>

    <div v-else class="stat-empty">
      <i class="bi bi-receipt"></i>
      <p class="mb-0">سفارشی برای نمایش وجود ندارد.</p>
    </div>
  </div>
</template>

<script>
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "StaticBiggestSell",
  data() {
    return {
      order: {},
    }
  },
  computed: {
    hasOrder() {
      return this.order && Object.keys(this.order).length > 0
    },
    userFullName() {
      const user = this.order.user || {}
      return ((user.name || '') + ' ' + (user.last_name || '')).trim() || 'بدون نام'
    },
    userInitial() {
      const name = this.userFullName
      return name ? name.charAt(0) : '؟'
    },
    paymentDate() {
      if (!this.order.transaction || !this.order.transaction.updated_at) {
        return '-'
      }
      return dateConverter(this.order.transaction.updated_at, '/', true)
    },
  },
  methods: {
    formatNumber,
    getBiggestSell() {
      this.$store.dispatch('Statistic/biggestSell').then(res => {
        this.order = res.data.data
      })
    },
  },
  async mounted() {
    await this.getBiggestSell()
  }
}
</script>
